import { combineReducers } from 'redux'
import createReducer, { createActions } from '@app-store/slices/availableCalendar/create'
import editReducer, { editActions } from '@app-store/slices/availableCalendar/edit'
import oneAvailableCalendarReducer, {
    oneAvailableCalendarActions
} from '@app-store/slices/availableCalendar/oneAvailableCalendar'
import validateLinkNameReducer, { validateLinkNameActions } from '@app-store/slices/availableCalendar/validateLinkName'

export const availableCalendarReducers = combineReducers({
    create: createReducer,
    edit: editReducer,
    oneAvailableCalendar: oneAvailableCalendarReducer,
    validateLinkName: validateLinkNameReducer
})

export const availableCalendarActions = {
    create: createActions,
    edit: editActions,
    oneAvailableCalendar: oneAvailableCalendarActions,
    validateLinkName: validateLinkNameActions
}
